import Styles from './LogoMarquee.module.css'

export interface LogoMarqueeProps {
  title: string
  logos: string[]
}

export const defaultProps: Partial<LogoMarqueeProps> = {}

export const LogoMarquee = (props: LogoMarqueeProps) => {
  const initializedProps: LogoMarqueeProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  return <div className={Styles['LogoMarquee']}>LogoMarquee</div>
}
